import { ReactNode } from 'react';
import './StatusMessage.css';

const ICONS: Record<string, string> = {
    error: '\u2716',
    success: '\u2714',
    warning: '\u26A0',
};

interface StatusMessageProps {
    type?: 'error' | 'success' | 'warning';
    title?: string;
    messages?: string[];
    children?: ReactNode;
}

function StatusMessage({ type = 'error', title, messages, children }: StatusMessageProps) {
    return (
        <div className={`status-message status-${type}`} role="alert">
            <span className="status-icon">{ICONS[type]}</span>
            <div className="status-content">
                {title && <div className="status-title">{title}</div>}

                {messages && messages.length > 0 && (
                    <ul className="status-list">
                        {messages.map((msg, idx) => (
                            <li key={idx}>{msg}</li>
                        ))}
                    </ul>
                )}

                {children}
            </div>
        </div>
    );
}

export default StatusMessage;
